import * as enUS from './en-US.json';
import * as esES from './es-ES.json';
import * as esUS from './es-US.json';

export const TRANSLATIONS = {
  'en-US': enUS,
  'es-ES': esES,
  'es-US': esUS,
};
